import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimes = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "X icon" }), /* @__PURE__ */ _jsx("g", {
		id: "X icon",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12.783079,12.0004775 L21.8357112,2.95296758 L21.8357112,2.95296756 C22.0534914,2.7369659 22.0549421,2.38530712 21.8389503,2.16751706 C21.7338798,2.06157122 21.5906005,2.00236196 21.4413942,2.00323006 L21.4413942,2.00323006 C21.2937735,2.00237654 21.1518871,2.06033268 21.0470771,2.16429684 L11.9999987,11.2173608 L2.95292028,2.16429684 L2.95292029,2.16429685 C2.73692893,1.94650568 2.38528693,1.94505552 2.16750726,2.16105756 C2.06156647,2.26613309 2.00236004,2.40941921 2.00322809,2.55863259 L2.00322808,2.55863481 C2.00237519,2.70626251 2.06032964,2.84815568 2.16428884,2.95297017 L11.216921,12.0004801 L2.16428884,21.04799 L2.16428879,21.0479901 C1.94650856,21.2639917 1.94505792,21.6156505 2.16104979,21.8334406 C2.2661203,21.9393864 2.40939959,21.9985957 2.55860585,21.9977276 L2.55860587,21.9977276 C2.70622654,21.9985811 2.84811294,21.940625 2.95292298,21.8366608 L12.0000014,12.7835968 L21.0470798,21.8366608 L21.0470798,21.8366608 C21.264855,22.0544464 21.6179399,22.0544464 21.835714,21.8366608 C22.0534892,21.6188752 22.0534892,21.2657735 21.835714,21.047989 C21.835714,21.047989 21.835714,21.047989 21.835714,21.047989 L12.783079,12.0004775 Z",
			id: "X icon",
			fill: "#4431AF"
		})
	})]
});
export default SvgTimes;
